import { ChangeDetectionStrategy, Component, ContentChild, Input } from '@angular/core'
import { AbstractColumn } from '@shared/components/tables/abstract-column'
import { MatFormFieldControl } from '@angular/material/form-field'

@Component({
  selector: 'lin-table-header-default-control',
  templateUrl: './table-header-default-control.component.html',
  styleUrls: ['./table-header-default-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableHeaderDefaultControlComponent extends AbstractColumn {
  @Input() sticky: boolean
  @Input() stickyEnd: boolean

  @ContentChild(MatFormFieldControl, { static: true }) control: MatFormFieldControl<any>
}
